import React, { Suspense, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App.tsx'
import { installChunkReloadGuard } from './chunkReloadGuard'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/charts/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/spotlight/styles.css'
import '@mantine/tiptap/styles.css'
import 'mantine-datatable/styles.css'
import '@teletienda/shared-ui-lib/dist/shared-ui-lib.css'
import './styles/preferences.css'
// Initialize i18n (no blocking - uses React Suspense for lazy loading)
import './i18n/config'

// SFU-1: recover from stale-chunk errors after a deploy (registers before lazy chunks load)
installChunkReloadGuard()

// Simple loading fallback while i18n loads (spinner already visible in HTML)
function I18nLoadingFallback() {
  return null // Spinner is already shown in index.html
}

// Wrapper to hide initial loader when React mounts
function AppWrapper() {
  useEffect(() => {
    // Hide the initial HTML spinner when React is ready
    document.body.classList.add('app-loaded')
  }, [])

  return <App />
}

// Render immediately - i18n loads lazily via Suspense
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense fallback={<I18nLoadingFallback />}>
      <AppWrapper />
    </Suspense>
  </React.StrictMode>,
)